import { Box, FocusTrap } from '@youversion/design-system-components';
import { m } from 'framer-motion';
import React from 'react';

interface ModalProps {
  children: React.ReactNode;
  initial?: boolean;
  onClose?: () => void;
}

const modalClasses = `
  z-20 fixed w-full md:max-w-[500px] md:h-[80vh] md:max-h-[800px] h-full
  top-1/2 left-1/2 md:-translate-y-1/2 md:-translate-x-1/2 overflow-hidden
  bg-canvas-secondary-light dark:bg-canvas-dark
  top-0 left-0 md:rounded-2
`;

export default function Modal({ onClose, children, initial = true }: ModalProps) {
  return (
    <FocusTrap>
      <Box className='size-full z-20 absolute inset-0'>
        <m.div
          animate={{ opacity: 1 }}
          className='fixed inset-0 bg-overlay-light dark:bg-overlay-dark'
          data-testid='dialog-overlay'
          exit={{ opacity: 0 }}
          id='overlay'
          initial={{ opacity: initial ? 0 : 1 }}
          key='overlay'
          onClick={onClose}
          transition={{ ease: 'easeInOut' }}
        />
        <m.div
          animate={{ opacity: 1, x: '-50%', y: '-50%' }}
          className={modalClasses}
          data-testid='dialog-content'
          exit={{ opacity: 0, x: '-50%', y: '-50%' }}
          initial={
            initial
              ? { opacity: 0, x: '-50%', y: window.innerWidth > 639 ? '-45%' : '-50%' }
              : { opacity: 1, x: '-50%', y: '-50%' }
          }
          key='modal'
          transition={{ ease: 'easeInOut' }}
        >
          {children}
        </m.div>
      </Box>
    </FocusTrap>
  );
}
